import SharedCheckout from "pages/checkout/Checkout";
import { StorefrontLayoutProvider } from "storefronts/StorefrontLayoutBridge";
import StorefrontLayout from "../components/StorefrontLayout";

export default function CheckoutPage() {
  return (
    <StorefrontLayoutProvider layout={StorefrontLayout}>
      <SharedCheckout />
    </StorefrontLayoutProvider>
  );
}
